import { useEffect } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { SearchCore } from './SearchCore';

interface SearchOverlayProps {
  open: boolean;
  onClose: () => void;
}

export function SearchOverlay({ open, onClose }: SearchOverlayProps) {
  // Close on Escape
  useEffect(() => {
    if (!open) return;
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center pt-[15vh]">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-xl mx-4 animate-slide-up">
        <SearchCore mode="overlay" onSelect={onClose} />
      </div>
    </div>
  );
}

/**
 * Hook to bind Cmd+K / Ctrl+K to open the search overlay.
 */
export function useSearchHotkey(setOpen: (open: boolean) => void) {
  useHotkeys(
    'mod+k',
    (e) => {
      e.preventDefault();
      setOpen(true);
    },
    { enableOnFormTags: true },
  );
}
